// extracted by mini-css-extract-plugin
export default {"root":"StageDependencies_root__SNvLT","tags-wrapper":"StageDependencies_tags-wrapper__1jLYS"};